/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Skip_For_NowInputs */

const en_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip for now`)
};

const de_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überspringen`)
};

const fr_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer pour l'instant`)
};

const es_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir por ahora`)
};

const it_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta per ora`)
};

const nl_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu overslaan`)
};

const pl_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomiń na teraz`)
};

const fi_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohita nyt`)
};

const da_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spring over for nu`)
};

const sv_common_skip_for_now = /** @type {(inputs: Common_Skip_For_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppa över för nu`)
};

/**
* | output |
* | --- |
* | "Skip for now" |
*
* @param {Common_Skip_For_NowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_skip_for_now = /** @type {((inputs?: Common_Skip_For_NowInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Skip_For_NowInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_skip_for_now(inputs)
	if (locale === "fr") return fr_common_skip_for_now(inputs)
	if (locale === "es") return es_common_skip_for_now(inputs)
	if (locale === "it") return it_common_skip_for_now(inputs)
	if (locale === "nl") return nl_common_skip_for_now(inputs)
	if (locale === "pl") return pl_common_skip_for_now(inputs)
	if (locale === "fi") return fi_common_skip_for_now(inputs)
	if (locale === "da") return da_common_skip_for_now(inputs)
	if (locale === "sv") return sv_common_skip_for_now(inputs)
	return en_common_skip_for_now(inputs)
});